﻿import { useEffect } from 'react';

import { FeatureFlagContext, FeatureFlagDetailsContext } from 'pages/account/feature_flag/context';
import { FeatureFlagDetail } from 'pages/account/feature_flag/FeatureFlagDetail';
import { type FeatureFlagPermissions } from 'pages/account/feature_flag/types';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { FeatureFlag } from 'pages/account/feature_flag/FeatureFlag';
import { NotificationContextProvider } from 'app/notifications';
import { TabsContextProvider } from 'components/Tabs/Tabs';
import { DefaultLayout } from 'components/layout';
import { useParams } from 'react-router-dom';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

export type FeatureFlagContextValue = {
    permissions: FeatureFlagPermissions
}

export const FeatureFlagWrapper = () => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        loading: true,
        permissions: null as FeatureFlagPermissions
    });

    const { loading, permissions } = state;

    const { id } = useParams();

    const fetchPermissions = async () => {

        try {

            const permissions = await PermissionsApi.Get('FeatureFlag');
            setState({
                loading: false,
                permissions
            });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    const context: FeatureFlagContextValue = {
        permissions
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'manage_feature_flags.9637e309', defaultMessage: 'Manage Feature Flags' })}>
            <FeatureFlagContext.Provider value={context}>
                <TabsContextProvider disableUrlSync context={FeatureFlagDetailsContext}>
                    <NotificationContextProvider>
                        {loading ?
                            (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                                    <GMetrixLoader/>
                                </div>
                            )
                            :
                            (
                                id ? <FeatureFlagDetail /> : <FeatureFlag />
                            )
                        }
                    </NotificationContextProvider>
                </TabsContextProvider>
            </FeatureFlagContext.Provider>
        </DefaultLayout>
    );

};